(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jj-atelier-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jj-mag]').forEach(function (mag) {
    var track = mag.querySelector('[data-jj-mag-track]');
    var current = mag.querySelector('[data-jj-mag-current]');
    var spreads = mag.querySelectorAll('[data-jj-mag-spread]');
    if (!track || spreads.length === 0) return;
    function page() {
      return Math.min(spreads.length - 1, Math.round(track.scrollLeft / track.clientWidth));
    }
    function update() {
      if (current) current.textContent = String(page() + 1).padStart(2, '0');
    }
    function go(delta) {
      var target = Math.max(0, Math.min(spreads.length - 1, page() + delta));
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }
    var prev = mag.querySelector('[data-jj-mag-prev]');
    var next = mag.querySelector('[data-jj-mag-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-size-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jj-sg]').forEach(function (sg) {
    var btns = sg.querySelectorAll('[data-jj-units]');
    function apply(u) {
      sg.querySelectorAll('[data-u]').forEach(function (el) { el.hidden = el.dataset.u !== u; });
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.jjUnits === u)); });
      try { localStorage.setItem('jj-units', u); } catch (e) {}
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.jjUnits); }); });
    var saved = 'm';
    try { saved = localStorage.getItem('jj-units') || 'm'; } catch (e) {}
    apply(saved === 'i' ? 'i' : 'm');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
